module.exports = __webpack_public_path__ + "img/shopcart.c68224ce.svg";